import { SVGProps } from "react";

export function OneIDFailIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <circle cx={44} cy={44} r={36} fill="#DEDFE0" opacity={0.2} />
      <rect width={40} height={56} x={10} y={16} fill="#D5E8EA" rx={2} />
      <path
        fill="#AACFD3"
        d="M29.674 32.822C21.566 32.822 15 39.402 15 47.511c0 8.108 6.566 14.688 14.674 14.688 8.123 0 14.703-6.58 14.703-14.688s-6.58-14.689-14.703-14.689Zm10.18 8.813H35.52a22.984 22.984 0 0 0-2.027-5.229 11.794 11.794 0 0 1 6.36 5.23ZM29.688 35.82a20.693 20.693 0 0 1 2.805 5.816h-5.61a20.693 20.693 0 0 1 2.805-5.816Zm-11.37 14.63a12.107 12.107 0 0 1-.381-2.938c0-1.014.147-1.998.382-2.938h4.964c-.117.97-.205 1.939-.205 2.938 0 .998.088 1.968.205 2.937H18.32Zm1.205 2.937h4.333a22.991 22.991 0 0 0 2.027 5.23 11.732 11.732 0 0 1-6.36-5.23Zm4.333-11.75h-4.333a11.731 11.731 0 0 1 6.36-5.23 22.989 22.989 0 0 0-2.027 5.23Zm5.832 17.567a20.692 20.692 0 0 1-2.806-5.817h5.611a20.692 20.692 0 0 1-2.805 5.817Zm3.437-8.755h-6.874c-.133-.97-.235-1.938-.235-2.937 0-1 .102-1.983.235-2.938h6.874c.132.955.235 1.939.235 2.938 0 .998-.103 1.968-.235 2.937Zm.367 8.167a22.987 22.987 0 0 0 2.027-5.229h4.333a11.795 11.795 0 0 1-6.36 5.23Zm2.6-8.167c.117-.97.205-1.938.205-2.937 0-1-.088-1.969-.205-2.938h4.965c.235.94.382 1.924.382 2.938 0 1.013-.147 1.997-.382 2.937h-4.965Z"
      />
      <rect
        width={26}
        height={6}
        x={17}
        y={22}
        fill="#fff"
        opacity={0.9}
        rx={1}
      />
      <rect width={54} height={34} x={28} y={46} fill="#33777E" rx={2} />
      <rect
        width={42}
        height={3}
        x={34}
        y={71}
        fill="#fff"
        opacity={0.9}
        rx={1.5}
      />
      <rect
        width={26}
        height={3}
        x={50}
        y={64}
        fill="#fff"
        opacity={0.6}
        rx={1.5}
      />
      <rect
        width={26}
        height={3}
        x={50}
        y={58}
        fill="#fff"
        opacity={0.6}
        rx={1.5}
      />
      <rect
        width={26}
        height={3}
        x={50}
        y={52}
        fill="#fff"
        opacity={0.6}
        rx={1.5}
      />
      <rect
        width={12}
        height={15}
        x={34}
        y={52}
        fill="#fff"
        opacity={0.9}
        rx={2}
      />
      <circle cx={69} cy={21} r={6.667} fill="#fff" />
      <path
        fill="#E44968"
        d="M69.021 21.75a1.1 1.1 0 0 0 .802-.344 1.1 1.1 0 0 0 .344-.802v-2.792c0-.305-.115-.569-.344-.791a1.117 1.117 0 0 0-.802-.333c-.306 0-.573.114-.802.343a1.1 1.1 0 0 0-.344.802v2.792c0 .305.115.57.344.792.229.222.496.333.802.333ZM69 25.521c.292 0 .545-.1.76-.302a1.02 1.02 0 0 0 .323-.781c0-.292-.108-.546-.323-.761a1.038 1.038 0 0 0-.76-.323c-.292 0-.545.108-.76.323a1.041 1.041 0 0 0-.323.761c0 .32.108.58.323.781.215.201.468.302.76.302ZM69 30c-1.25 0-2.42-.236-3.51-.708a9.136 9.136 0 0 1-2.855-1.927 9.136 9.136 0 0 1-1.927-2.855A8.737 8.737 0 0 1 60 21c0-1.25.236-2.424.708-3.521a9.093 9.093 0 0 1 1.927-2.864 8.973 8.973 0 0 1 2.855-1.917A8.846 8.846 0 0 1 69 12c1.25 0 2.424.233 3.521.698a8.932 8.932 0 0 1 2.864 1.917 8.932 8.932 0 0 1 1.917 2.864A8.925 8.925 0 0 1 78 21c0 1.25-.233 2.42-.698 3.51a8.973 8.973 0 0 1-1.917 2.855 9.093 9.093 0 0 1-2.864 1.927A8.815 8.815 0 0 1 69 30Z"
      />
    </svg>
  );
}
